var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0982 7.73331C3.99227 7.73393 3.88855 7.70298 3.80028 7.64442C3.712 7.58586 3.64316 7.50234 3.60254 7.4045C3.56192 7.30667 3.55135 7.19895 3.57219 7.09508C3.59302 6.99122 3.64432 6.89591 3.71954 6.82131L6.5462 3.99998L3.71954 1.17864C3.63216 1.07662 3.58651 0.945377 3.59169 0.811149C3.59687 0.676922 3.65252 0.549594 3.7475 0.454611C3.84249 0.359627 3.96981 0.303983 4.10404 0.298799C4.23827 0.293614 4.36951 0.339271 4.47154 0.426645L7.67154 3.62664C7.77087 3.72657 7.82663 3.86175 7.82663 4.00264C7.82663 4.14354 7.77087 4.27872 7.67154 4.37864L4.47154 7.57864C4.3722 7.67718 4.23812 7.73272 4.0982 7.73331Z",
    fill: "#676767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.89819 7.73331C0.792257 7.73393 0.688541 7.70299 0.600263 7.64442C0.511986 7.58586 0.443148 7.50234 0.402526 7.4045C0.361904 7.30667 0.351338 7.19895 0.372175 7.09509C0.393012 6.99122 0.444308 6.89591 0.519524 6.82131L3.34619 3.99998L0.519524 1.17865C0.419095 1.07822 0.362675 0.942008 0.362675 0.799981C0.362675 0.657953 0.419095 0.521743 0.519524 0.421314C0.619952 0.320886 0.756163 0.264465 0.89819 0.264465C1.04022 0.264465 1.17643 0.320886 1.27686 0.421314L4.47686 3.62131C4.57619 3.72124 4.63195 3.85642 4.63195 3.99731C4.63195 4.13821 4.57619 4.27339 4.47686 4.37331L1.27686 7.57331C1.22746 7.62371 1.16856 7.6638 1.10356 7.69126C1.03856 7.71873 0.968754 7.73302 0.89819 7.73331Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRightArrow);
export default __webpack_public_path__ + "static/media/DoubleRightArrow.eb522d13b374fef9dbff1aa2979cb019.svg";
export { ForwardRef as ReactComponent };